import {ICasinofiedApplicationAdapter} from "./casinofied-application-adapter.interface";
import {AppIdentifiers, IDivHostedAppInitParameters} from "@sparkware/uc-sdk-core";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";

export class CasinofiedRegularApplicationAdapter implements ICasinofiedApplicationAdapter {
    constructor(private readonly applicationObject, private readonly services: IServiceFactoryExtended) {
    }

    private initParams: IDivHostedAppInitParameters;
    init(initParams: IDivHostedAppInitParameters) {
        this.applicationObject.init(initParams);
        this.initParams = initParams;
    }

    closeIntent(appID: AppIdentifiers, correlationID: string): void {
        if(this.initParams) {
            this.services.messageBroker.channels.session.topics.closeIntent.publish({
                publisher: AppIdentifiers.CasinoClient,
            }, {
                appID: appID,
                correlationID: correlationID,
                launchInfo: this.initParams.applicationContext?.launchInfo
            });
        }
    }

    focus(): void {
        //nothing to do here
    }

    dispose() {
        //nothing to do here
    }
}